import { TFunction } from "utils";

import { ComponentWithGoalScores, CropMixComposerCommercialMix, GOAL_LEVEL_2, GoalScore, ScoreFactors } from "models";

import { TopMatchCardCommercialMix } from "pages/app/crop-mix-composer/components/commercialMix/TopMatchCard";
import { UnifiedGoalScoreItem, calculateUnifiedGoalScores } from "pages/app/crop-mix-composer/utils/cropMixComposer.tsx";

export const createTopMatchCardProps = (
  commercialMix: CropMixComposerCommercialMix,
  t: TFunction,
  selectedGoals: GOAL_LEVEL_2[],
  scoreFactors?: ScoreFactors
): TopMatchCardCommercialMix => ({
  id: commercialMix.id,
  provider: commercialMix.provider,
  name: commercialMix.name,
  mixItem: commercialMix.components.map((component) => ({ name: t(`practices:crops.${component.name}`), weightShare: component.weightProportion })),
  link: commercialMix.link,
  goalScores: scoreFactors ? calculateCommercialMixGoalScores(commercialMix.components, selectedGoals, scoreFactors) : [],
  matchScore: commercialMix.matchScore,
});

/**
 * Calculates goal scores for commercial mix components
 * Now uses the unified goal score calculation function
 */
export const calculateCommercialMixGoalScores = (
  components: ComponentWithGoalScores[],
  selectedGoals: GOAL_LEVEL_2[],
  scoreFactors: ScoreFactors
): GoalScore[] => {
  // Transform ComponentWithGoalScores to UnifiedGoalScoreItem
  const unifiedItems: UnifiedGoalScoreItem[] = components.map((component) => ({
    goalScores:
      component.goalScores?.map((score) => ({
        level2: score.level2 as GOAL_LEVEL_2,
        score: score.score,
      })) ?? [],
    weightShare: component.weightProportion,
    cropFamily: component.cropFamily,
  }));

  return calculateUnifiedGoalScores(unifiedItems, selectedGoals, scoreFactors);
};
